import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import GroupChatAPI from "../../../api/GroupChatAPI";
import Sidebar from "arui-feather/sidebar";
import toast from "react-hot-toast";
import FaqItemForm from "../tools/FaqItemForm";

export default function FaqItemsPanel(props) {
    const {canEdit = true} = props;

    const [items, setItems] = useState([]);
    const [selectedId, setSelectedId] = useState(undefined);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const selectedItem = useMemo(() => items.find(x => x.id === selectedId), [items, selectedId]);

    useEffect(() => {
        GroupChatAPI.getFaqItems().then(x => {
            setItems(x);
        });
    }, []);

    return (
        <Wrapper>

            <div className={'text-xl font-bold'} >FAQ</div>


            <div className={'w-full'} >
                {items.map(x => (
                    <div key={x.id} className={'p-4 cursor-pointer shadow w-full border-gray-200'} style={{width: '100%'}} >
                        <div className={'text-md font-bold'} >{x.ruName}</div>
                        <div className={'text-md font-bold'} >{x.enName}</div>

                        <div>{x.ruDescription}</div>

                        <div>{x.enDescription}</div>
                        {canEdit == false ? null :
                            <div className={'mt-1 mb-1'} >
                                <button className={'text-sm text-gray underline'} onClick={() => {
                                    setSelectedId(x.id);
                                }}>Редактировать
                                </button>
                            </div>
                        }
                    </div>
                ))}
            </div>

            <div className={'mt-4 mb-4'} >
                <button onClick={() => {
                    setCreateModalOpen(true);
                }}>Добавить
                </button>
            </div>

            <Sidebar visible={(selectedItem != undefined)} width={Math.min(1020, window.innerWidth)}
                     onCloserClick={() => {
                         setSelectedId(undefined);
                     }}>

                {selectedItem == undefined ? null :
                    <div>

                        <FaqItemForm {...selectedItem}
                                     canDelete={true}
                                  onSave={async d => {
                                      setLoading(true);
                                      await GroupChatAPI.updateFaqItem({ ...d, id: selectedItem?.id });
                                      let arr = await GroupChatAPI.getFaqItems();
                                      setItems(arr);
                                      setLoading(false);
                                      setSelectedId(undefined);
                                  }}
                                  onDelete={async () => {
                                      setLoading(true);
                                      await GroupChatAPI.deleteFaqItem(selectedItem?.id);
                                      let arr = await GroupChatAPI.getFaqItems();
                                      setItems(arr);
                                      setLoading(false);
                                      setSelectedId(undefined);
                                      toast.success("Удалено");
                                  }}
                        />

                    </div>
                }

            </Sidebar>

            <Sidebar visible={createModalOpen} onCloserClick={() => {
                setCreateModalOpen(false);
            }}>

                {createModalOpen == false ? null :
                    <div>
                        <FaqItemForm

                            onSave={async d => {
                                await GroupChatAPI.createFaqItem(d);
                                setItems(await GroupChatAPI.getFaqItems());
                                setCreateModalOpen(false);
                            }}
                        />
                    </div>
                }

            </Sidebar>


        </Wrapper>
    );
}

const Wrapper = styled.div`

`;